import * as types from './mutation-types'

const mutations = {
  [types.DATA_EDIT_LIST_DATA] (state, payload) {
    state.dataListData = payload
  },
  [types.DATA_EDIT_PUSH_TARGET] (state, targetHistoryDB) {
    state.pushTarget = targetHistoryDB
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/modules/data-edit/mutations.js